import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  employees: [],
  error: null,
  message: '',
};
const EmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_EMPLOYEE_MASTER_REQUEST:
    case actionTypes.GET_EMPLOYEES_REQUEST:
    case actionTypes.UPDATE_EMPLOYEES_REQUEST:
    case actionTypes.DELETE_EMPLOYEES_REQUEST:
    case actionTypes.MULTIDELETE_EMPLOYEES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPLOAD_EMPLOYEE_MASTER_SUCCESS:
    case actionTypes.UPDATE_EMPLOYEES_SUCCESS:
    case actionTypes.MULTIDELETE_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: action.payload,
      };
    case actionTypes.GET_EMPLOYEES_SUCCESS:
    case actionTypes.DELETE_EMPLOYEES_SUCCESS:
      return {
        ...state,
        loading: false,
        employees: action.payload,

      }

    case actionTypes.UPLOAD_EMPLOYEE_MASTER_FAILURE:
    case actionTypes.GET_EMPLOYEES_FAILURE:
    case actionTypes.UPDATE_EMPLOYEES_FAILURE:
    case actionTypes.DELETE_EMPLOYEES_FAILURE:
    case actionTypes.MULTIDELETE_EMPLOYEES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default EmployeeReducer
